const PoweredByEasebuzz = () => (
  <div className="bmc-poweredby">
    <span className="bmc-poweredby-label">Powered By</span>
    <svg
      className="bmc-eb-icon"
      viewBox="0 0 27 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M9.197 2.98975H25.383L23.5632 6.51266C23.3766 6.87506 23.1019 7.17741 22.7679 7.38804C22.4338 7.59866 22.0527 7.70981 21.6644 7.70985H6.7609L9.197 2.98975Z" fill="#517CE3"/>
      <path d="M2.5983 10.0122H18.7844L16.9644 13.5351C16.7779 13.8975 16.5032 14.1999 16.1691 14.4105C15.835 14.6211 15.4539 14.7323 15.0656 14.7323H0.1621L2.5983 10.0122Z" fill="#85E6C4"/>
      <path d="M9.197 17.0283H25.383L23.5632 20.5512C23.3766 20.9136 23.1019 21.216 22.7679 21.4266C22.4338 21.6372 22.0527 21.7484 21.6644 21.7484H6.7609L9.197 17.0283Z" fill="#6D44E5"/>
    </svg>
    <span className="bmc-eb-name">Easebuzz</span>
  </div>
);

export default PoweredByEasebuzz;
